export default __webpack_public_path__ + "static/microservice-133f34ab784f9c91da42c2251e2706d1.svg";